import { request } from 'shared/lib/request';

export const getDebtorsRequest = ({ id, currentExercice, transition }) =>
  request.get(
    `/dashboards/${id}/debtors?exercice=${currentExercice}&transition=${transition}`
  );

export const getDebtorData = ({ dosId, ...data }) =>
  request.post(`dashboards/${dosId}/debtors/detailed`, data);
